import { IOption } from 'components/ui/select'

export default [
  {
    label: 'Bitte wählen',
    value: '',
  },
  {
    label: '1 bis 10',
    value: 10,
  },
  {
    label: '11 bis 20',
    value: 20,
  },
  {
    label: '21 bis 50',
    value: 50,
  },
  {
    label: 'mehr als 100',
    value: 101,
  },
] as IOption[]
